import { Form } from "formik";
import { chakra } from "@chakra-ui/react";

const StyledForm = chakra(Form);

export default StyledForm;
